<template>
  <Modal
    :id="modalId"
    :title="modalTitle"
    :buttonName="buttonText"
    @button="mainButtonAction()"
    :disabled="canGoNext"
    backButtonName="Back"
    @back="state = 'WAITING_PAYMENT_TYPE_CHECK'"
    :isBackArrow="true"
    :backArrowVisible="isBackVisible"
    arrowBackText="Back"
    @show="reloadPoints()"
    data-cy="modalTradeItem"
    :materialButton="true"
    class="modal-trade-item"
  >
    <RequestPaymentType
      v-if="state === 'WAITING_PAYMENT_TYPE_CHECK'"
      :item="item"
      @chosenPayment="paymentBy"
      @insuficentFunds="insuficientPoints = !insuficientPoints"
      :choice="paymentType"
    />
    <div class="message-to-user">
      <span>Send a message to  @{{ this.item.user.username }} if you want to negotiate a different price:</span>
      <SButtonMaterial
        class="send-msg-item-btn"
        buttonType="button"
        iconColor="white"
        iconWithoutText="message"
        materialClass="dense"
        color="primary"
        @button="openChat(item)"
      />
      <md-tooltip
        md-direction="bottom"
        class="s-tooltip"
        >Chat</md-tooltip
      >
    </div>
    <div
      v-if="state === 'WAITING_USER_INPUT' || state === 'ERROR_SENDING_MESSAGE'"
    >
      <span class="additional-message">Send an additional message to @{{ this.item.user.username }}:</span>
      <textarea
        class="form-control"
        v-model="message"
        ref="textArea"
        data-cy="textareaTradeItem"
      />
      <p v-if="state === 'ERROR_SENDING_MESSAGE'" class="text-danger mt-3 mb-0">
        {{ errorMessage }}
      </p>
    </div>

    <ResponsabilityTerms
      @check="setChecked"
      v-if="
        state === 'WAITING_PAYMENT_TYPE_CHECK' ||
        (state === 'WAITING_USER_INPUT' && isItemFree)
      "
      :itemType="item.type"
      :poster="item.posterId"
      data-cy="termsTradeItem"
      class="mt-3"
    />
    <div v-else-if="state === 'SENDING_MESSAGE'">
      <LoadingSpinner position="relative" />
    </div>

    <div v-else-if="state === 'MESSAGE_SENT'" class="msg-sent-container">
      <span class="sent-title">Congratulations!</span>
      <span
        class="msg-sent-tex"
        data-cy="sentMessageTradeItem"
        v-html="messageSent"
      >
      </span>
    </div>
    <div v-else-if="state === 'INSUFFICIENT_FUNDS'">
      <p class="text-danger">
        {{ insufficientFundsText }}
      </p>
      <span class="additional-message">Send an additional message:</span>
      <textarea
        class="form-control"
        v-model="message"
        ref="textArea"
        data-cy="textareaTradeItem"
      />
      <p v-if="state === 'ERROR_SENDING_MESSAGE'" class="text-danger mt-3 mb-0">
        {{ errorMessage }}
      </p>

      <div v-else-if="state === 'SENDING_MESSAGE'">
        <LoadingSpinner position="relative" />
      </div>

      <div v-else-if="state === 'MESSAGE_SENT'" class="msg-sent-container">
        <span class="sent-title">Congratulations!</span>
        <span
          class="msg-sent-tex"
          data-cy="sentMessageTradeItem"
          v-html="messageSent"
        >
        </span>
      </div>
      <div v-else-if="state === 'INSUFFICIENT_FUNDS'">
        <p class="text-danger">
          {{ insufficientFundsText }}
        </p>
      </div>
    </div>
  </Modal>
</template>

<script>
import Modal from "@/components/atoms/Modal.vue";
import ResponsabilityTerms from "@/components/molecules/ResponsabilityTerms";
import RequestPaymentType from "@/components/molecules/RequestPaymentType";
import { mapGetters, mapActions } from "vuex";
import itemType from "@/enum/item-type";
import ChatHelperVue from "../../mixins/ChatHelper.vue";
import PointsHelperVue from "../../mixins/PointsHelper.vue";
import UserHelperVue from "../../mixins/UserHelper.vue";
import ItemHelperVue from "../../mixins/ItemHelper.vue";
import LoadingSpinner from "@/material-components/atoms/LoadingSpinner.vue";
import SButtonMaterial from "@/material-components/atoms/SButtonMaterial.vue";

export default {
  name: "ModalTradeItem",
  props: ["item"],
  mixins: [PointsHelperVue, ItemHelperVue, ChatHelperVue, UserHelperVue],
  components: {
    Modal,
    ResponsabilityTerms,
    RequestPaymentType,
    LoadingSpinner,
    SButtonMaterial
  },
  data() {
    return {
      state: "WAITING_PAYMENT_TYPE_CHECK",
      message: "",
      result: "",
      checkTerms: false,
      checkPayment: false,
      paymentType: null,
      modalTitle: "",
      insufficientFundsText: "",
      insuficientPoints: false,
      messageSent: "",
    };
  },
  methods: {
    ...mapActions(["makeItemRequest", "fetchMyPointSum"]),
    destroyModal() {
      this.$destroy();
    },
    reloadPoints() {
      this.fetchMyPointSum();
    },
    setChecked(c) {
      this.checkTerms = c;
    },
    paymentBy(type) {
      if (this.insuficientPoints === true) this.insuficientPoints = false;
      this.checkPayment = true;
      this.paymentType = type;
    },
    async sendMessage() {
      if (this.paymentType === "points") {
        const type = this.item.type;
        if (type === itemType.GIVE || type === itemType.LEND) {
          if (this.checkFunds(this.item.points)) {
            this.state = "SENDING_MESSAGE";
            await this.sendRequestAndMsg();
          } else {
            this.state = "INSUFFICIENT_FUNDS";
            this.insufficientFundsText = `You don't have enough points to complete this transaction.
              Earn more points by posting items or invite friends to try this transaction again.`;
            this.messageUserFundsInsufficient();
          }
        } else {
          this.state = "SENDING_MESSAGE";
          const response = await this.checkPosterAvailablePointSum({
            itemId: this.item.id,
          });
          if (response.result === "Available points") {
            this.state = "SENDING_MESSAGE";
            await this.sendRequestAndMsg();
          } else if (
            response.result === "Available point balance is not enough"
          ) {
            this.state = "INSUFFICIENT_FUNDS";
            this.insufficientFundsText = `${this.getPosterName(
              this.item
            )} doesn't have enough points for this transaction.`;
          } else {
            this.state = "INSUFFICIENT_FUNDS";
            this.insufficientFundsText = "Something went wrong.";
          }
        }
      } else {
        this.state = "SENDING_MESSAGE";
        await this.sendRequestAndMsg();
      }
    },
    async sendRequestAndMsg() {
      try {
        await this.sendItemRequest();
        if (!this.result.error) {
          await this.postUserItemMessage({
            partner: this.item.posterId,
            item: this.item.id,
            postMsg: this.message,
            newChat: true,
          });
          this.text = this.defaultMessage;
          this.state = "MESSAGE_SENT";
        } else {
          this.state = "ERROR_SENDING_MESSAGE";
          this.text = this.result.error;
        }
      } catch (err) {
        this.state = "ERROR_SENDING_MESSAGE";
        console.error(err);
      }
    },
    async sendItemRequest() {
      try {
        this.result = await this.makeItemRequest({
          itemId: this.item.id,
          paymentBy: this.paymentType,
        });
      } catch (error) {
        console.log(error);
      }
    },
    async messageUserFundsInsufficient() {
      const msg = `Unfortunately you didn't have enough points to complete the transaction.
        Earn more points by posting items or invite friends to try this transaction again.`;
      await this.sendSystemNotification({
        partnerId: this.loggedUser.id,
        msg: msg,
        type: "INSUFFICIENT_FUNDS",
      });
    },
    setWaitingState() {
      if (this.item.cash !== 0 || this.item.points !== 0) {
        if (this.item.cash && !this.item.points) {
          this.state = "WAITING_USER_INPUT";
          this.paymentBy("money");
        } else if (this.item.points && !this.item.cash) {
          this.state = "WAITING_USER_INPUT";
          this.paymentBy("points");
        } else {
          this.state = "WAITING_PAYMENT_TYPE_CHECK";
        }
      } else {
        this.state = "WAITING_USER_INPUT";
        this.focusInput();
      }
    },
    setErrorSendingState() {
      if (
        this.result.error &&
        this.result.error === "User has an open request for the same item"
      ) {
        $(`#${this.modalId}`).modal("hide");
      } else {
        this.sendMessage();
      }
    },
    mainButtonAction() {
      switch (this.state) {
        case "WAITING_USER_INPUT":
          this.sendMessage();
          break;
        case "MESSAGE_SENT":
          $(`#${this.modalId}`).modal("hide");
          break;
        case "INSUFFICIENT_FUNDS":
          $(`#${this.modalId}`).modal("hide");
          break;
        case "WAITING_CHECK":
          this.setWaitingState();
          break;
        case "WAITING_PAYMENT_TYPE_CHECK":
          this.state = "WAITING_USER_INPUT";
          this.focusInput();
          break;
        case "ERROR_SENDING_MESSAGE":
          this.setErrorSendingState();
          break;
        default:
          return;
      }
    },

    focusInput() {
      this.$nextTick(() => {
        this.$refs.textArea.focus();
      });
    },
    openChat(key) {
      const selectedKeyId = key.id ?? key.group.id;
      const msgs = this.userMessages.some((msg) => {
        return msg.key.id === selectedKeyId;
      });
      if (!msgs) {
        this.selectedKeyChat = {
          key: key,
          messages: [],
          firstTalk: true,
        };
      } else {
        this.selectedKeyChat = this.userMessages.find((msg) => {
          return msg.key.id === selectedKeyId;
        });
      }
      this.selectedKeyChat = {
        ...this.selectedKeyChat,
        partner: key.user,
      };
      console.log(this.selectedKeyChat)
      this.setPopupChat({
        isOpen: true,
        chatMsgs: this.selectedKeyChat,
      });
      this.$parent.$refs.rightStickyBar.openClosePopup();
    }
  },
  computed: {
    ...mapGetters({
      user: "getUser",
    }),
    modalId() {
      return `trade-item-${this.itemId}`;
    },
    itemId() {
      return this.item && this.item.id;
    },
    isItemFree() {
      return this.item.points === 0 && this.item.cash === 0;
    },
    buttonText() {
      switch (this.state) {
        case "WAITING_USER_INPUT":
          if (
            this.item.type === itemType.GIVE ||
            this.item.type === itemType.LEND
          ) {
            return "Request";
          } else if (
            this.item.type === itemType.RECEIVE ||
            this.item.type === itemType.BORROW
          ) {
            return "Offer";
          }
          return "Send message";
        case "MESSAGE_SENT":
          return "OK";
        case "ERROR_SENDING_MESSAGE":
          if (
            this.result.error &&
            this.result.error === "User has an open request for the same item"
          ) {
            return "OK";
          }
          return "Send message";
        case "WAITING_CHECK":
        case "WAITING_PAYMENT_TYPE_CHECK":
          return "Next";
        default:
          return "OK";
      }
    },
    errorMessage() {
      if (
        this.result.error &&
        this.result.error === "User has an open request for the same item"
      ) {
        return "OPS, you have already requested this item.";
      }
      return "An error ocurred when trying to send message. Try again!";
    },
    canGoNext() {
      switch (this.state) {
        case "SENDING_MESSAGE":
          return true;
        case "WAITING_PAYMENT_TYPE_CHECK":
          if (this.insuficientPoints === true) return true;
          if (!this.checkPayment || !this.checkTerms) {
            return true;
          }
          return false;
        case "WAITING_USER_INPUT":
          if (this.isItemFree && !this.checkTerms) return true;
          return false;
        default:
          return false;
      }
    },
    isBackVisible() {
      return !!(this.state === "WAITING_USER_INPUT" && !this.isItemFree);
    },
  },
  mounted() {
    if (this.isItemFree) this.state = "WAITING_USER_INPUT";
    setTimeout(() => {
      if (this.item && this.item.type && this.item.type !== undefined) {
        const itemName = this.item.title;
        let defaultMessage = "";
        let defaultMessageSent = "";
        const type = this.item.type;
        if (type === itemType.GIVE || type === itemType.LEND) {
          defaultMessage = `Hi, I am requesting the item ${itemName}`;
          this.modalTitle = "Request item";
          defaultMessageSent = `We have sent your request to <strong>${this.getPosterName(
            this.item
          )}</strong>. Watch your account or email for a response.`;
        } else if (type === itemType.RECEIVE || type === itemType.BORROW) {
          defaultMessage = `Hi, I am offering the item ${itemName}`;
          this.modalTitle = "Offer item";
          defaultMessageSent = `We have sent your offer to <strong>${this.getPosterName(
            this.item
          )}</strong>. Watch your account or email for a response.`;
        }
        this.message = defaultMessage;
        this.messageSent = defaultMessageSent;
      }
    }, 2000);
  },
};
</script>

<style>
.modal-trade-item .modal-body {
  padding: 25px 34px 23px !important;
}
</style>

<style lang="scss" scoped>
.send-msg-item-btn {
  width: 1em;
  min-width: 2em !important;
  min-height: 1.5em !important;
  border-radius: 4px;
  i {
    font-size: 25px !important;
  }
  margin-left: 1em;
}

.message-to-user{
  margin-top: 1em;
}
.s-tooltip {
  background: rgba(147, 147, 147, 0.4);
  backdrop-filter: blur(3px);
  -webkit-backdrop-filter: blur(3px);
  border-radius: 4px;
  color: $black;
  font-weight: 500;
  
}
.additional-message {
  font-size: 18px;
  line-height: 20px;
  letter-spacing: 1.25px;
  color: $black;
  display: flex;
  margin-bottom: 1.5rem;
  font-weight: normal;
}
.form-control {
  border: 1px solid $dark !important;
}
.msg-sent-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  span {
    font-size: 16px;
    line-height: 20px;
    text-align: center;
    letter-spacing: 1.25px;
    color: #000000;
  }
  .sent-title {
    margin-top: 4rem;
    margin-bottom: 3rem;
  }
  .msg-sent-tex {
    margin-bottom: 2rem;
  }
}
textarea.form-control:focus {
  border: 1px solid $primary !important;
}
</style>
